module.exports = {"buildVersion":"2.17.14-220317378","release":"2.17.14","buildDateTime":"Thu Mar 17 2022 12:36"}


//////////////////
// WEBPACK FOOTER
// ./src/metadata.json
// module id = 2099
// module chunks = 23